import Info from '../../components/common/Info';
import RoundInfo from '../../components/common/RoundInfo';
import SubInfo from '../../components/common/SubInfo';
import { imageUrl } from '../../utils';

const GlobalCoverage = () => {
  return (
    <div className="flex w-full justify-center px-4 md:px-6 xl:px-8">
      <div className="flex w-full max-w-[1100px] flex-col items-stretch gap-2 md:flex-row md:items-start md:justify-center md:gap-6 lg:gap-10">
        <div className="flex w-full flex-col items-start md:max-w-[520px] md:w-auto">
          <RoundInfo containerClasses="mb-4 md:mb-6">{'Around the clock'}</RoundInfo>
          <Info
            variant="h2"
            className="lg:!text-[42px] md:!text-[28px] !text-[28px]"
            containerClasses="mb-4 md:mb-6">
            {'US leadership. Global engineering coverage.'}
          </Info>
          <SubInfo>
            {
              'Our distributed team works across US and Asia time zones, so development, QA, and handoffs continue beyond a single workday.'
            }
          </SubInfo>
          <SubInfo containerClasses="mt-4">
            {
              'As one team signs off, another can pick up the work. When your US or Asia team starts the day, they can already see progress made overnight — with fixes implemented, reviews completed, and the next steps ready to go.'
            }
          </SubInfo>
        </div>
        <div className="flex w-full flex-col items-start pt-6 md:max-w-[300px] md:shrink-0 lg:max-w-[480px] lg:pt-10">
          <blockquote className="relative mb-8 w-full">
            <span
              aria-hidden
              className="pointer-events-none absolute -top-5 left-0 select-none text-[56px] font-medium leading-none text-yellow"
              style={{ fontFamily: 'var(--fontBase)' }}>
              “
            </span>
            <p
              className="relative pt-4 text-[18px] font-medium leading-[1.3] tracking-[-0.02em] text-light-black md:text-[22px]"
              style={{ fontFamily: 'var(--fontBase)' }}>
              Your work doesn’t have to stop
              <span className="mt-1 block">
                <span className="box-decoration-clone rounded-md bg-yellow px-1.5 py-0.5">when your workday ends.</span>
              </span>
            </p>
          </blockquote>
          <div className="w-full overflow-hidden rounded-2xl">
            <img
              src={imageUrl('global-coverage.svg')}
              alt="Globe showing Las Vegas at 6 PM and Asia at 9 AM, one day ahead"
              className="mx-auto h-auto w-full max-h-[210px] object-contain object-center lg:max-h-[250px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalCoverage;
